import React, { PropsWithChildren } from "react";
import OrigSEO from "gatsby-theme-networked-thought/src/components/seo";

export default function SEO({ children, ...rest }: PropsWithChildren<any>) {
  return (
    <OrigSEO {...rest}>
      <link href="https://github.com/ekampf" rel="me" />
      {children}
    </OrigSEO>
  );
}
